import './style.css';
/**
 * @module view/Devices
 */

import {
  Navigate,
  Outlet,
  useParams
} from 'react-router-dom';
import {
  useEffect,
} from 'react';
import { DevicesList } from './components/devices-list';
import { LoadingIndicator } from '@thermon-platforms/thermon-ui-core';
import useAlarmsStore from 'store/alarms';
import useDevicesStore from 'store/devices';
import useDeviceTypesStore from 'store/device-types';
import useSessionStore from 'store/session';


/**
 * @function Devices
 * @memberof module:view/Devices
 * @returns {ReactElement}
 */
function Devices() {
  const params = useParams();
  const [, alarmsStoreActions] = useAlarmsStore();
  const [devicesStore, devicesStoreActions] = useDevicesStore();
  const [deviceTypesStore, deviceTypesStoreActions] = useDeviceTypesStore();
  const [sessionStore] = useSessionStore();
  const site = devicesStore.devices?.find(device => device.type == 'Site');

  useEffect(() => {
    alarmsStoreActions.query();

    if (!devicesStore.devices.length && !devicesStore.loading && !devicesStore.error) {
      devicesStoreActions.query();
    }
    if (!deviceTypesStore.types.length && !deviceTypesStore.loading && !deviceTypesStore.error) {
      deviceTypesStoreActions.query();
    }
  }, []);

  return (
    <div className="view devices">
      <DevicesList />
      {/* If devices aren't ready, let's show a loading indicator */
        devicesStore.loading ? <LoadingIndicator /> :
          /* Otherwise, show our device details if a device route is selected */
          Object.keys(params).length ? <Outlet /> :
            site ?
            <Navigate to={`/devices/${sessionStore.recentDevice.length ? sessionStore.recentDevice.join('/') : site?.id}`} replace={true} />
            : <Navigate to={`/get-started`} replace={true} />
      }
    </div>
  )
}

export default Devices;
